// eslint-disable-next-line no-shadow
export enum EPortInStep {
    getCode, // 0 Initial step, no portIn has been started yet
    verifyCode, // 1 PortIn started but not fulfilled, waiting for the verification code
    successCode, // 2 PortIn is fulfilled
}

export const isSuccess = (step: EPortInStep) => step === EPortInStep.successCode;

export const isGettingCode = (step: EPortInStep) => step === EPortInStep.getCode;

export const isVerifying = (step: EPortInStep) => step === EPortInStep.verifyCode;
